import { Duration as DurationWithMinMax } from '@reward-platform/ancillaries-schemas/common'
import { compareMinMaxDuration, Duration, minutesToDuration } from '~/utils/datetime'
import { useTranslations, useFormatter } from 'next-intl'

export const useDateMessageFormatters = () => {
  const t = useTranslations('common.labels')
  const format = useFormatter()

  const formatDays = (count?: number) => (count ? t('days', { count }) : false)

  const formatHours = (count?: number) => (count ? t('hours', { count }) : false)

  const formatMinutes = (count?: number) => (count ? t('minutes', { count }) : false)

  const formatTime = (dateTime: string) =>
    format.dateTime(new Date(dateTime), {
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    })

  const formatDuration = (duration: Duration) =>
    [formatDays(duration.days), formatHours(duration.hours), formatMinutes(duration.minutes)]
      .filter((v) => v)
      .join(', ')

  const formatDurationWithMinMax = (duration: DurationWithMinMax) => {
    if (duration?.minDuration !== undefined && duration.maxDuration !== undefined) {
      const minDurationObject = minutesToDuration(duration.minDuration)
      const maxDurationObject = minutesToDuration(duration.maxDuration)

      const minValue = compareMinMaxDuration(minDurationObject, maxDurationObject)
      const minDuration =
        typeof minValue === 'number' ? minValue : formatDuration(minDurationObject)
      return `${minDuration} to ${formatDuration(maxDurationObject)}`
    }
    if (duration?.duration) {
      return formatDuration(minutesToDuration(duration.duration))
    }
    return duration?.freeText
  }

  return {
    formatDays,
    formatHours,
    formatMinutes,
    formatTime,
    formatDuration,
    formatDurationWithMinMax,
  }
}
